import { render, staticRenderFns } from "./dialog-observacao.vue?vue&type=template&id=6cee9ea6"
import script from "./dialog-observacao.vue?vue&type=script&lang=js"
export * from "./dialog-observacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports